import { TimelineMax, Expo } from 'gsap';

export default function staggerFade(el) {
  const tl = new TimelineMax({
    paused: true,
  });

  const p = Array.from(el.querySelectorAll('p'));

  tl
    .addLabel('start')
    .staggerTo(p, 1, {
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeOut,
    }, 0.2, 'start');

  return tl;
}
